// 路由缓存
class RouteCache {
  constructor() {
    this.cache = new Map();
  }

  addRoute(routePath) {
    if (routePath && typeof routePath === 'string') {
      this.cache.set(routePath, true);
    }
  }

  hasRoute(routePath) {
    return this.cache.has(routePath);
  }
}

export const routeCache = new RouteCache();
export default routeCache;
